import { Action } from 'redux';
import { PaymentDataInterface } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/on-exchange-payment.interface';
import { OnExchangeEnrollmentPaymentFormStateStructure, ON_EXCHANGE_PAYMENT_METHODS } from '../../angular-elements/shared/interfaces/on-exchange-enrollment-payment-form.interface';

const INITIAL_STATE: OnExchangeEnrollmentPaymentFormStateStructure = {
  marketplacePaymentOptions: {
    selectedPaymentType: null
  },
  marketplacePaymentInfo: {
    [ON_EXCHANGE_PAYMENT_METHODS.BANK_ACCOUNT]: null,
    [ON_EXCHANGE_PAYMENT_METHODS.CREDIT_CARD]: null
  },
  marketplacePaymentReview: null,
  marketplacePaymentConfirmation: null,
  paymentManagerServiceData: null,
  paymentManagerServiceConfirmationNum: null
};

class OnExchangeEnrollmentPaymentFormAction implements Action {
  type: string;
  onExchangeEnrollmentPaymentForm?: OnExchangeEnrollmentPaymentFormStateStructure;
  paymentManagerServiceData?: PaymentDataInterface;
  paymentManagerServiceConfirmationNum?: string;
}

const SET_PAYMENT_MANAGER_SERVICE_CONFIRMATION_NUM = 'SET_PAYMENT_MANAGER_SERVICE_CONFIRMATION_NUM';
const SET_PAYMENT_MANAGER_SERVICE_DATA = 'SET_PAYMENT_MANAGER_SERVICE_DATA';

export function setPaymentManagerServiceConfirmationNum(paymentManagerServiceConfirmationNum: string): OnExchangeEnrollmentPaymentFormAction {
  return { type: SET_PAYMENT_MANAGER_SERVICE_CONFIRMATION_NUM, paymentManagerServiceConfirmationNum };
}
export function setPaymentManagerServiceData(paymentManagerServiceData: PaymentDataInterface): OnExchangeEnrollmentPaymentFormAction{
  return { type: SET_PAYMENT_MANAGER_SERVICE_DATA, paymentManagerServiceData };
}

export const ON_EXCHANGE_ENROLLMENT_PAYMENT_FORM_REDUCER_NAME = 'onExchangeEnrollmentPaymentForm';
export function onExchangeEnrollmentPaymentForm(
  state: OnExchangeEnrollmentPaymentFormStateStructure = INITIAL_STATE,
  action: OnExchangeEnrollmentPaymentFormAction
) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SET_PAYMENT_MANAGER_SERVICE_DATA:
      copiedState.paymentManagerServiceData = action.paymentManagerServiceData;
      return Object.assign({}, state, copiedState);
    case SET_PAYMENT_MANAGER_SERVICE_CONFIRMATION_NUM:
      copiedState.paymentManagerServiceConfirmationNum = action.paymentManagerServiceConfirmationNum;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}

